
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.94 33.94"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Laag_2","data-name":"Laag 2"}},[_c('g',{attrs:{"id":"Laag_1-2","data-name":"Laag 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M32.84 32.84H1.09v-2.19h31.75zM2.19 1.1h29.56v28.46H2.19zm31.2 28.46h-.55V.55a.54.54 0 00-.55-.55H1.64a.55.55 0 00-.55.55v29H.55a.54.54 0 00-.55.55v3.28a.55.55 0 00.55.55h32.84a.55.55 0 00.55-.55v-3.27a.55.55 0 00-.55-.55"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M15.33 27.37H4.38V3.28h11zm.54-25.18h-12a.55.55 0 00-.55.55v25.18a.55.55 0 00.55.54h12a.54.54 0 00.55-.54V2.74a.54.54 0 00-.55-.55m13.69 25.18H18.61V3.28h11zm.55-25.18h-12a.54.54 0 00-.54.55v25.18a.54.54 0 00.54.54h12a.54.54 0 00.54-.54V2.74a.54.54 0 00-.54-.55"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M20.8 11h6.57v1H20.8zm4.7 2.73h-2.83l-.55-.54h3.93zM24.63 17a.55.55 0 11-1.09 0v-2.22h1.09zm-4.38-3.83h.32l1.48 1.48a.59.59 0 00.39.16V17a1.65 1.65 0 003.29 0v-2.22a.55.55 0 00.38-.16l1.49-1.48h.32a.55.55 0 00.54-.55V10.4a.55.55 0 00-.54-.55h-7.67a.55.55 0 00-.54.55v2.19a.55.55 0 00.54.55"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M21.35 23A1.65 1.65 0 0023 21.35v-.28a.27.27 0 01.27-.27.28.28 0 01.28.27v2.47a1.64 1.64 0 003.28 0V20a.27.27 0 01.27-.27 1.37 1.37 0 001.37-1.37v-4.13h-1.1v4.11a.27.27 0 01-.28.27A1.36 1.36 0 0025.73 20v3.56a.55.55 0 01-1.1 0v-2.49a1.37 1.37 0 00-2.74 0v.28a.54.54 0 01-.54.54.55.55 0 01-.55-.54v-7.12h-1.09v7.12A1.64 1.64 0 0021.35 23"}})])])])
          )
        }
      }
    